import { BODY_SM_SM_MEDIUM_STYLES, BODY_XS_XS_MEDIUM_STYLES, HEADING_XXXS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const LogInfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const LogInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs, 8px);
`;

export const LogInfoText = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const LogInfoTextBold = styled.div<{ $color?: string }>`
    color: ${({ $color }) => $color ?? 'var(--colors-text-body, #50566E)'};
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const Label = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_XXXS_STYLES};
`;

export const Rating = styled.div<{
    $isSelected?: boolean;
    $hasAssessorOrAssesseeSelection?: boolean;
    $selectedBackground?: string;
    $isInactive?: boolean;
}>`
    ${BODY_XS_XS_MEDIUM_STYLES};
    box-sizing: border-box;
    text-align: center;
    display: flex;
    height: 44px;
    padding: 6px var(--spacing-sm, 16px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-2xs, 4px);
    flex: 1 0 0;
    color: ${({ $isSelected, $hasAssessorOrAssesseeSelection }) =>
        $isSelected
            ? 'var(--colors-text-on-action, #FFF)'
            : $hasAssessorOrAssesseeSelection
              ? 'var(--colors-text-action, #2171C6)'
              : 'var(--colors-text-disabled, #B4B8BF)'};
    font-weight: ${({ $hasAssessorOrAssesseeSelection }) => ($hasAssessorOrAssesseeSelection ? 700 : 500)};
    border: ${({ $hasAssessorOrAssesseeSelection }) =>
        $hasAssessorOrAssesseeSelection
            ? 'var(--border-width-lg-4, 4px) solid rgba(33, 113, 198, 0.40)'
            : 'var(--border-width-sm-1, 1px) solid var(--colors-border-disabled, #D3DBE5)'};
    border-radius: ${({ $hasAssessorOrAssesseeSelection }) =>
        $hasAssessorOrAssesseeSelection ? 'var(--border-radius-none, 0)' : undefined};
    background: ${({ $isSelected, $selectedBackground, $isInactive }) => {
        if ($isSelected) {
            return $selectedBackground;
        }

        if ($isInactive) {
            return 'var(--neutral-100, #f9fafb)';
        }

        return 'transparent';
    }};

    &:first-child {
        border-radius: ${({ $hasAssessorOrAssesseeSelection }) =>
            $hasAssessorOrAssesseeSelection
                ? 'var(--border-radius-none, 0)'
                : 'var(--border-radius-s_8, 8px) 0 0 var(--border-radius-s_8, 8px)'};
    }

    &:last-child {
        border-radius: ${({ $hasAssessorOrAssesseeSelection }) =>
            $hasAssessorOrAssesseeSelection
                ? 'var(--border-radius-none, 0)'
                : '0 var(--border-radius-s_8, 8px) var(--border-radius-s_8, 8px) 0'};
    }
`;

export const StatusInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const StatusTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    margin-right: var(--spacing-sm, 16px);
`;

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs, 8px);
`;

export const ReferenceContentWrapper = styled.div`
    padding: 14px 16px;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--neutral-100, #f9fafb);
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const CommentsContent = styled.div`
    padding: 14px 16px;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--neutral-100, #f9fafb);
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const DateWrapper = styled.div`
    text-align: right;
`;
